module.exports = __webpack_public_path__ + "static/nick-color-e90f722b2e098a9e84d449fc9c51effe.png";